
const classPrefix = 'special-offer-product'
const dataPrefix = 'data-special-offer-product'

const $container = document.querySelector(`[${dataPrefix}]`)

if ($container) {
    serviceСard();
}

export function serviceСard() {

}
